module.exports = __webpack_public_path__ + "static/fonts/iconfont.cd5b7e6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/alfont/iconfont.woff?t=1697420656926
// module id = 2Pus
// module chunks = 74